import React from 'react';
import dateFormat from 'date-fns/format';
import {
	AreaChart,
	Area,
	linearGradient,
	ResponsiveContainer,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
} from 'recharts';

// import { LoaderIcon } from '../Loader/puff';

import { moneyFormatter, dateFromString } from '@utils/customLib';
import { getINRDecimals } from '@utils/params';

const formatTickData = (price, numFractDigits) => {
	if (Math.floor(price / 1000) === 0) {
		return moneyFormatter(price, {
			minimumFractionDigits: 0,
			maximumFractionDigits: numFractDigits,
		});
	}

	return `${moneyFormatter(price / 1000, {
		minimumFractionDigits: numFractDigits,
		maximumFractionDigits: 1,
	})}k`;
};

const calculateWidth = (min, max) => {
	const numFractDigits = max - min > 1000 ? 0 : 1;
	const width =
		Math.max(
			formatTickData(min, numFractDigits).length,
			formatTickData(max, numFractDigits).length
		) * 6;
	return width;
};

// const LoadableChart = Loadable({
// 	loader: () =>
// 		import(
// 			/* webpackChunkName: "recharts", webpackMode: "lazy-once" */ 'recharts'
// 		),
// 	loading: ({ error }) => {
// 		if (error) {
// 			return <div className="container ">Something went wrong!!</div>;
// 		}
// 		return (
// 			<div className="pt-12 pb-8 skeleton-wrapper">
// 				<img
// 					src="https://bitbns.com/assets/img/graph-loader.svg"
// 					style={{ opacity: 0.4 }}
// 					alt="Loading..."
// 				/>
// 			</div>
// 		);
// 	},
// 	delay: 0,
// 	render(loaded, props) {
// 		const  = loaded;

// 	},
// });

const CChart = React.memo(
	({ min, max, coin, sym, market_id, chartData, currentTab }) => {
		const numFractDigits = max - min > 1000 ? 0 : 1;

		return (
			<div id="chart__container">
				<ResponsiveContainer height={180}>
					<AreaChart
						width={730}
						height={300}
						data={chartData}
						margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
					>
						<defs>
							<linearGradient
								id="colorUv"
								x1="0"
								y1="0"
								x2="0"
								y2="1"
							>
								<stop
									offset="5%"
									stopColor="#d9d4ed"
									stopOpacity={1}
								/>
								<stop
									offset="95%"
									stopColor="#d9d4ed"
									stopOpacity={0.05}
								/>
							</linearGradient>
						</defs>
						<XAxis
							dataKey="name"
							axisLine={false}
							tick={{
								fontSize: '12px',
								fill: '#a4a4a4',
							}}
							tickLine={{
								stroke: '#ccc',
							}}
							tickFormatter={time =>
								currentTab !== 2
									? `${dateFormat(
											dateFromString(time),
											'dd MMM'
									  )}`
									: `${dateFormat(
											dateFromString(time),
											'hh mm a'
									  )}`
							}
						/>
						<YAxis
							hide
							axisLine={false}
							tick={false}
							tickLine={false}
							width={calculateWidth(min, max)}
							tickFormatter={price =>
								formatTickData(price, numFractDigits)
							}
							padding={{ top: 20, bottom: 10 }}
							domain={['dataMin', 'dataMax']}
						/>
						<CartesianGrid stroke="#eee" vertical={false} />
						<Tooltip
							formatter={val =>
								`${sym}${moneyFormatter(val, {
									minimumFractionDigits: 0,
									maximumFractionDigits: getINRDecimals(
										coin,
										market_id
									),
								})}`
							}
							labelStyle={{
								fontSize: '11px',
								color: 'rgb(127, 136, 157)',
							}}
							labelFormatter={val =>
								currentTab !== 2
									? dateFormat(
											dateFromString(val),
											'dd MMM yy HH:mm'
									  )
									: dateFormat(dateFromString(val), 'hh:mm a')
							}
							itemStyle={{ fontSize: '12px' }}
							wrapperStyle={{
								background: 'rgba(255,255,255,.5)',
								border: 'none',
								textTransform: 'uppercase',
							}}
						/>
						<Area
							dataKey={coin}
							stroke="#4f4677"
							fillOpacity={1}
							isAnimationActive={false}
							fill="url(#colorUv)"
						/>
					</AreaChart>
				</ResponsiveContainer>
			</div>
		);
	}
);

export default CChart;
